import {
  BusinessClaimRequestType,
  BusinessClaimResponseType,
  BusinessMetadataType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
  generateSellarMetaData,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useBusinessClaim = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (request: {
      data: { id: number } & BusinessClaimRequestType;
      sellarMetadata?: BusinessMetadataType;
    }) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `businesses/${request.data.id}/claim`,
        data: request.data,
        sellarMetadata: request.sellarMetadata
          ? generateSellarMetaData(request.sellarMetadata)
          : undefined,
      }).then(
        (response) =>
          apiV2AssertResponse(response).data as BusinessClaimResponseType,
      ),

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Businesses],
      });
      queryClient.invalidateQueries({
        queryKey: [ServerStateKeys.BusinessUser],
      });
      queryClient.invalidateQueries({
        queryKey: [ServerStateKeys.SellarUser],
      });
    },
  });
};
